import React from 'react';
import { SafeComponent } from '@fiverr-private/orca';
import { Button } from '@fiverr-private/button';
import { Text } from '@fiverr-private/typography';
import { ArrowRightIcon } from '@fiverr-private/visuals';
import { Stack } from '@fiverr-private/layout_components';
import { theme } from '@fiverr-private/theme';
import { Image } from '@fiverr-private/media';
import { translate } from '@fiverr-private/i18n-react';
import { sendBigQueryEvent, sendMixPanelEvent } from '../../utils/biEvents';
import { MP_POPULAR_SERVICES_CLICKED } from '../../utils/biEvents/events/mixPanelEvents';
import { NEW_BADGE_WITH_GRADIENT_SRC } from './constants';

interface ServiceItemProps {
    index: number;
    elementName: string;
    labelKey: string;
    href: string;
    eventName: string;
    isNew?: boolean;
}

const ServiceItem = ({ elementName, labelKey, href, eventName, index, isNew }: ServiceItemProps) => {
    const sendServiceClickMixpanelEvent = () => {
        sendBigQueryEvent({ eventName });

        sendMixPanelEvent({
            eventName: MP_POPULAR_SERVICES_CLICKED,
            params: {
                element: elementName,
                order: index + 1,
            },
        });
    };

    return (
        <Button
            intent="primary"
            variant="outline"
            colorScheme="white"
            size="md"
            target="_blank"
            onClick={sendServiceClickMixpanelEvent}
            href={href}
            flex={{ default: 'auto', md: '1 1 auto' }}
            style={{ maxWidth: 'max-content', backgroundColor: theme.colors.white_10 }}
        >
            <Stack alignItems="center" textOverflow="ellipsis" overflow="hidden" whiteSpace="nowrap">
                <Text
                    color="white"
                    whiteSpace="nowrap"
                    textOverflow="ellipsis"
                    width="100%"
                    overflow="hidden"
                    textAlign="center"
                >
                    {translate(labelKey)}
                </Text>
                {isNew && <Image maxWidth="45px" height="24px" src={NEW_BADGE_WITH_GRADIENT_SRC} alt="new badge" />}
                {!isNew && <ArrowRightIcon />}
            </Stack>
        </Button>
    );
};

export default SafeComponent(ServiceItem);
